@if (view.avatar) {
  <img class="activity-item__avatar" [src]="view.avatar" alt="" width="48" height="48" />
} @else {
  <span class="activity-item__icon activity-item__icon--{{ view.tone }}" aria-hidden="true">
    <img [src]="iconPath + '/' + view.icon + '.svg'" alt="" width="24" height="24" />
  </span>
}
<div class="activity-item__content">
  <div class="activity-item__header">
    <span class="activity-item__name">
      @if (view.titleLink) {
        <a class="activity-item__title activity-item__link" [uiSref]="view.titleLink.state" [uiParams]="view.titleLink.params">{{ view.title }}</a>
      } @else {
        <span class="activity-item__title">{{ view.title }}</span>
      }
      @if (view.subtitle) {
        <span class="activity-item__subtitle">{{ view.subtitle }}</span>
      }
    </span>
    <span class="activity-item__age">
      @if (unread) {
        <img [src]="iconPath + '/unread-dot.svg'" alt="Unread" width="10" height="10" />
      }
      {{ view.date | relativeDate }}
    </span>
  </div>
  <p class="activity-item__text">
    @for (part of view.parts; track $index) {
      @if (part.state) {
        <a class="activity-item__link" [uiSref]="part.state" [uiParams]="part.params" [innerHTML]="part.text | emojiHtml"></a>
      } @else if (part.href) {
        <a class="activity-item__link" [href]="part.href" [innerHTML]="part.text | emojiHtml"></a>
      } @else {
        <!-- ng-container keeps the template's line breaks out of the sentence. -->
        <ng-container>{{ part.text }}</ng-container>
      }
    }
  </p>
</div>
